import { FormattedMessage } from "react-intl";
import { Table } from "core/table/Table";
import { Typography } from "core/typography/Typography";
import { useState, useEffect } from "react";
import {
  onAdd,
  onChange,
  onDelete,
  renderCommonBlock,
  renderStartDateEndDate,
} from "utils/tableContentHelper";
import { phoneSize } from "utils/screenSizes";
import PropTypes from "prop-types";
import { headerGenerator } from "utils/HeaderHelper";
import { MODAL_CONTENT } from "constants/constants";

const ManageLongLeave = ({
  userVacation,
  getUpdatedValues,
  lang,
  setElementsToDelete,
}) => {
  const headerParams = [
    {
      key: "start_date",
      defaultMessage: "Date de début",
      icon: "calendar",
      paddingLeft: ".75rem",
    },
    {
      key: "end_date",
      defaultMessage: "Date de fin",
      icon: "calendar",
      paddingLeft: ".75rem",
    },
    { key: "updated_by", defaultMessage: "Modifié par", icon: "user" },
    { key: "updated_at", defaultMessage: "le", icon: "calendar" },
  ];

  const header = headerGenerator(headerParams);

  const [data, setData] = useState(userVacation);
  const [initialData, setInitialData] = useState(userVacation);
  useEffect(() => {
    if (initialData.length < userVacation.length && userVacation.length > 0) {
      setData(userVacation);
      setInitialData(userVacation);
    }
  }, [userVacation, initialData]);

  const formatContent = (content) =>
    content.length > 0
      ? content?.map((elm, index) => {
          const dataTestIndex = content.length - 1 - index;
          return {
            id: elm?.id,
            ...renderStartDateEndDate({
              data,
              getUpdatedValues,
              start_date: elm?.start_date,
              end_date: elm?.end_date,
              setData,
              id: elm.id,
              onChangeDates: onChange,
              lang,
              modalType: MODAL_CONTENT.MANAGE_LONG_LEAVE,
              dataTestIndex,
            }),

            ...renderCommonBlock({
              data,
              getUpdatedValues,
              id: elm.id,
              onDelete,
              setData,
              updated_at: elm.updated_at,
              updated_by: elm.updated_by,
              lang,
              setElementsToDelete,
              deleteBtnTestId: `${MODAL_CONTENT.MANAGE_LONG_LEAVE}_modal-delete_btn-${dataTestIndex}`,
            }),
          };
        })
      : [];

  return (
    <>
      <button
        className="button-style"
        onClick={() => onAdd({ header, data, setData })}
        data-testid={`${MODAL_CONTENT.MANAGE_LONG_LEAVE}_modal-add_long_leave_btn`}
      >
        <Typography
          className="link-1 violet "
          type="h2"
          label={
            <>
              +{" "}
              <FormattedMessage
                id="add_long_vacation"
                defaultMessage="Ajouter un congé long"
              />
            </>
          }
        />
      </button>
      <br />

      <Table
        id="long_vacation"
        header={header}
        content={formatContent(data)}
        tableOverflow={"auto"}
        tableWidth={phoneSize ? "max-content" : "100%"}
      />
    </>
  );
};

ManageLongLeave.propTypes = {
  userVacation: PropTypes.array,
  getUpdatedValues: PropTypes.func,
  lang: PropTypes.string,
  setElementsToDelete: PropTypes.func,
};

export default ManageLongLeave;
